import cn from 'classnames'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { Box } from '@features/story/components/Box'

export function StoryField({ className }: { className?: string }) {
  const { data, isLoading } = useStoryReader()

  if (!data || data.bookStory?.length === 0 || isLoading) {
    return null
  }

  return (
    <>
      {data.bookStory?.map(item => (
        <Box
          key={item.name}
          className={cn(
            'card p-[30px] mobile:p-[20px] mobile:pb-0 dark:border-purple',
            className
          )}
        >
          <Box.Title className='dark:text-dark-10 text-2xl line-clamp-1 break-all mobile:mb-[10px]'>
            {item.name}
          </Box.Title>
          <p className='font-light text-secondary dark:text-dark-10 break-words desktop-tablet:mt-[20px]'>
            {item.content}
          </p>
        </Box>
      ))}
    </>
  )
}
